export default __webpack_public_path__ + "static/media/image-1.7e0383e1.webp";